import React, { memo, useMemo } from "react";
import { DropZone } from "../../../../components";
import { makeStyles } from "@material-ui/core/styles";
import { createFilePath } from "../../../Campaigns/Single/VoicePreview";
import {
  DROPZONE_UPLOAD_STATUS,
  DropZoneUploadStatusToColorMap,
} from "../constants";

const useStyles = makeStyles((theme) => ({
  fileSelector: {
    width: "100%",
    height: 120,
  },
}));

function VoiceFileInput({
  idx,
  readOnly,
  onUpload,
  onReject,
  error,
  label,
  dataTestId,
  filePath,
}) {
  const classes = useStyles();
  const color = useMemo(() => {
    if (readOnly) {
      return DropZoneUploadStatusToColorMap[DROPZONE_UPLOAD_STATUS.DISABLED];
    }
    if (error) {
      return DropZoneUploadStatusToColorMap[DROPZONE_UPLOAD_STATUS.REJECTED];
    }
    if (filePath) {
      return DropZoneUploadStatusToColorMap[DROPZONE_UPLOAD_STATUS.UPLOADED];
    }
    return DropZoneUploadStatusToColorMap[DROPZONE_UPLOAD_STATUS.NOT_STARTED];
  }, [error, filePath, readOnly]);

  return (
    <>
      <DropZone
        dataTestId={dataTestId}
        className={classes.fileSelector}
        color={color}
        accept=".mp3,.wav,.m4a,.ogg"
        multiple={false}
        onDropAccepted={(file) => onUpload(file, idx)}
        onDropRejected={() => onReject(idx)}
        label={label}
        variant="outlined"
        disabled={readOnly}
      />
      {filePath && !error ? (
        <audio
          controls
          className="my-2"
          style={{ height: "30px", width: "100%" }}
        >
          <source src={createFilePath(filePath)} type="audio/mpeg" />
          Your browser does not support the HTML audio
        </audio>
      ) : null}
    </>
  );
}
export default memo(VoiceFileInput);
